export default __webpack_public_path__ + "static/media/t_wdt_c_2.f285bc89.mp3";